//アプリ情報読込み
var listsy = [];
var optionlisty = ["予約販売"];
var displayCounty = 0;

//チェックボックスの備考メッセージ
var checkBoxMessagey ="※同意するにチェックをしてカートに入れるを押してください。";
var checkBoxCounty = 0;
var checkBoxCountLimity = 0;

//カスタムオーダールール呼び出し
var loadRulesIntervaly = setInterval(() => {
  window.customorderLoadRules(function () {
    window.GroovyCustomOrder.rules.forEach(function (rule) {

      if (rule != null) {
        if(optionlisty.indexOf(rule.name) !== -1) {
          rule.data.forEach(function (ru) {
            listsy.push(ru);
          })
        }
      }
    });

  });
  if (listsy.length > 0) {
    clearInterval(loadRulesIntervaly);
    createSorceCodey(listsy);
  }
}, 2500)

//商品ページへオプションの埋め込み
function createSorceCodey(optionlisty) {
  displayCounty++;
  //各要素のカウント
  checkBoxCountLimity = optionlisty.filter(n => n.type === 'checkbox').length;
  
  if(displayCounty === 1){
    var html = ``;
    optionlisty.forEach(function(option) {
      switch (option.type) {
        case "choices" :
          html += createChoices(option);
          break;
        case "select" :
          html += createDropDown(option);
          break;        
        case "checkbox" :
          html += createCheckBoxy(option);
          break;
        default:
          break;
      }
    });
    //選択しているオプションの金額を表示
    var customOrderOptionsElementy = document.getElementById('customOrderOptions');
    customOrderOptionsElementy.insertAdjacentHTML('afterbegin', html);
    
  }
}

//オプションタイプ　チェックボックス
function createCheckBoxy(element) {
  checkBoxCounty++;
  var html = ``;
  html = `<div class="customOrderOption">
            <div class="customOrderOptionTitlex">${element.name}</div>
            <div class="customOrderOptionElement checkBoxCustom">
              <input type="checkbox" class="${optionlisty[0]}" id="checkBox${checkBoxCounty}x" name="properties[${window.customOrderEscapeHtmlAttribute(element.name)}]" value="${window.customOrderEscapeHtmlAttribute(element.note)}">
              <span class="checkboxTitle">${element.note}</span>
            </div>
            <span class="customorderErrorx"><small>必須項目のため、選択してください / This option is required.</small></span> 
          </div>`;

  if(checkBoxCounty === checkBoxCountLimity) {
    html += `<span class="customHelpText"><small>${checkBoxMessagey}</small></span>`;
  }
  
  return html;
}

